const ATTACHABLE_CATEGORY_SELECTED_ATTACHABLES_UPDATED = (state, selectedAttachables) => {
  state.selectedAttachables = selectedAttachables;
};
const RESET_ATTACHABLE_CATEGORY_SELECTED_ATTACHABLES_UPDATED = (state) => {
  state.selectedAttachables = [];
};

export default {
  ATTACHABLE_CATEGORY_SELECTED_ATTACHABLES_UPDATED,
  RESET_ATTACHABLE_CATEGORY_SELECTED_ATTACHABLES_UPDATED,
};
